<aside
  role="region"
  [attr.aria-label]="'features.plan.panel.title' | translate"
  [class]="hostClass()">
  <header class="border-weak flex h-10 shrink-0 items-center gap-1 border-b pr-1.5 pl-3.5">
    <h2 class="text-text-primary flex-1 truncate text-sm font-semibold">
      {{ 'features.plan.panel.title' | translate }}
    </h2>
    <button
      type="button"
      data-testid="plan-panel-expand"
      class="btn btn-icon"
      [attr.aria-pressed]="panel.expanded()"
      [attr.aria-label]="'features.plan.panel.expand' | translate"
      [title]="
        (panel.expanded() ? 'features.plan.panel.collapse' : 'features.plan.panel.expand')
          | translate
      "
      (click)="panel.toggleExpanded()">
      <i
        [class]="panel.expanded() ? ICONS.arrowsInSimple : ICONS.arrowsOutSimple"
        aria-hidden="true"></i>
    </button>
    <button
      type="button"
      data-testid="plan-panel-close"
      class="btn btn-icon"
      [attr.aria-label]="'features.plan.panel.close' | translate"
      [title]="'features.plan.panel.close' | translate"
      (click)="close()">
      <i [class]="ICONS.x" aria-hidden="true"></i>
    </button>
  </header>

  <div [class]="bodyClass()">
    <div data-testid="plan-panel-column-left" [class]="leftColumnClass()">
      @for (entry of leftEntries(); track entry.section.id) {
        <ng-container *ngTemplateOutlet="frame; context: { $implicit: entry }" />
      }
    </div>
    <div data-testid="plan-panel-column-right" [class]="rightColumnClass()">
      @for (entry of rightEntries(); track entry.section.id) {
        <ng-container *ngTemplateOutlet="frame; context: { $implicit: entry }" />
      }
    </div>
  </div>
</aside>
@if (panel.expanded()) {
  <div
    data-testid="plan-panel-placeholder"
    aria-hidden="true"
    [class]="placeholderClass()"></div>
}

<ng-template #frame let-entry>
  <section class="border-weak border-b" [attr.data-section-id]="entry.section.id">
    <div class="flex items-center gap-1 pr-1.5">
      <h3 class="m-0 min-w-0 flex-1">
        <button
          type="button"
          data-testid="plan-panel-section-toggle"
          class="hover:bg-interactive text-text-primary flex h-9 w-full cursor-pointer items-center gap-2 pr-2 pl-3.5 text-left text-xs font-semibold transition-colors"
          [attr.id]="'plan-panel-section-' + entry.section.id + '-header'"
          [attr.aria-controls]="
            entry.collapsed() ? null : 'plan-panel-section-' + entry.section.id
          "
          [attr.aria-expanded]="!entry.collapsed()"
          (click)="panel.toggleSection(entry.section.id)">
          <i
            [class]="entry.section.icon"
            class="text-text-secondary"
            aria-hidden="true"></i>
          <span class="flex-1 truncate">{{ entry.section.titleKey | translate }}</span>
          <i
            [class]="entry.collapsed() ? ICONS.caretRight : ICONS.caretDown"
            class="text-text-tertiary"
            aria-hidden="true"></i>
        </button>
      </h3>
      @if (entry.section.headerActions; as actions) {
        <ng-container *ngComponentOutlet="actions" />
      }
    </div>
    @if (!entry.collapsed()) {
      <div
        role="region"
        class="px-3.5 pt-1.5 pb-3"
        [attr.id]="'plan-panel-section-' + entry.section.id"
        [attr.aria-labelledby]="'plan-panel-section-' + entry.section.id + '-header'">
        <ng-container *ngComponentOutlet="entry.section.component" />
      </div>
    }
  </section>
</ng-template>
